import React from 'react';
import { Reveal } from './Reveal';
import { CTAButton } from './CTAButton';
import { ImagePlaceholder } from './ImagePlaceholder';
import { previewItems } from '../data/previewItems';
export function PreviewSection() {
  return <section aria-labelledby="preview-title" className="bg-cream px-5 py-20 md:py-28" data-id="element-175" data-mp="2237i2ycvfsrw">
      <Reveal className="mx-auto max-w-content" data-id="element-176" data-mp="2720z30rda1wt">
        <div className="mx-auto max-w-2xl text-center" data-id="element-177" data-mp="274ww8mve4mk7">
          <p className="text-[11px] font-bold uppercase tracking-[0.18em] text-amber" data-id="element-178" data-mp="1sde7o0ogtjp8">INSIDE THE VOLUMES</p>
          <h2 id="preview-title" className="mt-4 text-3xl font-extrabold tracking-tight text-pine md:text-4xl" data-id="element-179" data-mp="1x6h188t8st5f">
            See Exactly What You Get. Really.
          </h2>
          <p className="mt-4 text-slate-body" data-id="element-180" data-mp="1neb98z2zqbq8">Real pages from the volumes. Nothing staged.</p>
        </div>
        <ul className="mt-12 grid gap-6 sm:grid-cols-2 md:grid-cols-3" data-id="element-181" data-mp="19gd0c97fv7i4">
          {previewItems.map(caption => <li key={caption} className="rounded-card bg-white p-3 shadow-lift" data-id="element-182" data-mp="1edvce8gr62uc">
              <ImagePlaceholder label="Page preview" ratio="aspect-[4/5]" data-id="element-183" data-mp="2cqy9zxnnymoz" />
              <p className="px-2 pb-1 pt-3.5 text-center text-xs font-medium leading-snug text-slate-body" data-id="element-184" data-mp="27tg3edx4cjk5">
                {caption}
              </p>
            </li>)}
        </ul>
        <div className="mt-12 flex justify-center" data-id="element-185" data-mp="2gturtm5dqerv">
          <CTAButton className="w-full max-w-md md:w-auto" data-id="element-186" data-mp="2gue70v3nap27" />
        </div>
      </Reveal>
    </section>;
}